import React from "react";
import {
  Accordion,
  ActionIcon,
  Avatar,
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  Flex,
  Grid,
  Group,
  Modal,
  Popover,
  Radio,
  ScrollArea,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { DateInput, TimeInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import { IconClock, IconInfoCircle } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  createNote,
  editNote,
  getSingleNote,
  updateNoteStatus,
} from "../../services/note";
import { getAllPatientsModal } from "../../services/patient";
import swal from "sweetalert";

import {
  decrypt,
  formatDate,
  getOptions,
  noteType_Client,
  noteType_Client_Options,
} from "../../utils";
import useStyles from "./styles";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { IconX } from "@tabler/icons-react";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { IconChevronDown } from "@tabler/icons-react";
import { ApprovedNoteSvg } from "../Svgs/ApprovedNoteSvg";
import { RejectNoteSvg } from "../Svgs/RejectNoteSvg";
import { getPendingActions, getPendingNotes, getTodaysNotes } from "../../services/dashboard";
import { MdPendingActions } from "react-icons/md";
import {
  Billing_Services_Note,
  Essential_Support_Note,
  Intervention_Progress_Note,
  Group_Note,
} from "../../http";
import { planTypeLabels } from "../MAR/ClientSupportPlans";
import ViewInfo from "./ViewInfo";
import EssentialViewInfo from "./EssentialViewInfo";
import NotePendingSvg from "../Svgs/NotePendingSvg";

const NoteModalNew = ({
  opened,
  close,
  title,
  view,
  hideApproveRejectButtons,
  setView,
  userId, //clientId
  noteType: NOTETYPE,
  ...data
}) => {
  // Get the current time in HH:mm:ss format
  const noteData = data;
  const { classes, cx } = useStyles();
  const ref = useRef();
  const edit = data.data ? true : false;
  const noteT = data?.data?.noteId;
  const { allNotesTypes, addNoteLoading } = useSelector((state) => state?.note);
  const { allPlans } = useSelector((state) => state?.supportPlan);
  const { profile } = useSelector((state) => state.profile);
  const { allPatients } = useSelector((state) => state?.patient);
  const [errors, setErrors] = useState({});
  const { allSignature } = useSelector((state) => state?.signature);

  const patientInfo = allPatients?.map((patient) => {
    return {
      selectedPatientId: patient?.id,
      label: patient?.name,
    };
  });

  const [medicationOptions, setMedicationOptions] = useState([]);
  const [supportOptions, setSupportOptions] = useState([]);
  const [outComeTitle, setOutComeTitle] = useState([]);
  const [outcomeNumbers, setOutComeNumbers] = useState([]);
  const [outcomeNotes, setOutcomeNotes] = useState([]);

  const [essentialNotes, setEssentialNotes] = useState([]);
  const [savePlanId, setSavePlanId] = useState("");

  const [essentialSupportType, setEssentialSupportType] = useState([]);
  const [essentialSupportNumber, setEssentialSupportNumber] = useState([]);

  const [displayAccordionTitle, setDisplayAccordionTitle] = useState(false);
  const [noteType, setNoteType] = useState(
    noteT
      ? allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)
      : allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)
  );
  const [selectedPatient, setSelectedPatient] = useState(null);
  const id = selectedPatient?.id;
  const clientId = id?.slice(-6);
  const [patientsId, setPatientsId] = useState(null);
  const isFacilityDisabled = noteType?.custom?.find((value) => {
    return (
      value?.fieldType?.name?.toLowerCase() ===
      noteType_Client_Options?.toLowerCase()
    );
  });

  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const [supportPlan, setSupportPlan] = useState("no");
  const [essentialSupportToggle, setEssentialSupportToggle] = useState("no");
  const [interventionPlanToggle, setInterventionPlanToggle] = useState("no");

  const [serviceNumber, setServiceNumber] = useState(null);

  const [reasonError, setReasonError] = useState("");

  const [essentialAccordion, setEssentialAccordion] = useState("0");
  const [goalsAccordion, setGoalsAccordion] = useState("0");

  const [essentialSupportCount, setEssentialSupportCount] = useState([]);

  const [noteRejectValue, setNoteRejectValue] = useState(null);
  const [noteRejectionDescp, setNoteRejectionDescp] = useState("");

  const [showRejection, setShowRejection] = useState(false);
  const [showRejectedNote, setShowRejectedNote] = useState(false);
  const [showApproved, setShowApproved] = useState(false);

  const [selectedFacility, setSelectedFacility] = useState();

  const icon = <DropDownArrowSvg style={{ width: rem(1), height: rem(1) }} />;

  const isBilling_Services = noteType?.id === Billing_Services_Note;
  const isGroupNote = noteType?.id === Group_Note;
  const groupClients = isGroupNote
    ? (data?.data?.fields?.clientIds || [])
        .map((id) => allPatients?.find((p) => p?.id === id))
        .filter(Boolean)
    : [];
  const [goalOptions, setGoalOptions] = useState([]);
  const [goalItems, setGoalItems] = useState([
    [{ id: Date.now(), objectives: "", Intervention_Instruction: "" }],
  ]);

  const initialDescription = {
    outcomeTitle: "",
    outcomeNumber: "",
    outComeCategory: "",
    description: "",
    details: null,
    error: "",
  };

  const initialEssentialSupport = {
    id: Date.now(),
    essentialSupportType: "",
    essentialActivityNumber: "",
    description: "",
  };

  const initialGoals = {
    id: Date.now(),
    goalNumber: "",
    goalNote: "",
    startTimeGoal: "",
    endTimeGoal: "",
    goalActivities: [
      { id: Date.now(), objectives: "", Intervention_Instruction: "" },
    ],
    behaviorDescription: "",
    responseDescription: "",
    planDescription: "",
  };

  const [descriptions, setDescriptions] = useState([
    { id: 1, ...initialDescription },
  ]);

  const [essentialSupport, setEssentialSupport] = useState([
    { id: 1, ...initialEssentialSupport },
  ]);

  const [goals, setGoals] = useState([{ id: 1, ...initialGoals }]);

  React.useEffect(() => {
    setDescriptions([{ id: 1, ...initialDescription }]);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    setGoals([{ id: 1, ...initialGoals }]);
  }, []);

  useEffect(() => {
    setShowRejectedNote(false);
    setShowRejection(false);
  }, [noteData?.data?.approvalStatus]);

  const [goalNumber, setGoalNumbers] = useState([]);
  // const [goalActivities, setGoalActivities] = useState([]);
  const [objectivesByGoal, setObjectivesByGoal] = useState([]);
  const [interventionsByGoal, setInterventionsByGoal] = useState([]);

  useEffect(() => {
    let outcomeTitle = [];
    let outcomeNumberArray = [];
    let essentialSupportArray = [];
    let essentialSupportNumber = [];
    let planIdToSave = null;
    let objectivesMap = [];
    let goalTitleOptions = [];
    let goalNumberOptions = [];
    let interventionsMap = [];

    if (noteType?.name === "Intervention Progress Note") {
      const filteredGoals = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.goals?.map((goal) => {
                if (edit) {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                    });

                    // goal.goalActivities?.map((act) =>
                    //   objectivesMap.push({
                    //     value: act.objectives,
                    //     label: act.objectives,
                    //   })
                    // );

                    // goal.goalActivities?.map((act) =>
                    //   interventionsMap.push({
                    //     value: act.Intervention_Instruction,
                    //     label: act.Intervention_Instruction,
                    //   })
                    // );
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    goalTitleOptions.push({
                      value: goal?.Identified_Relevant_Attainable_Goals,
                      label: goal?.Identified_Relevant_Attainable_Goals,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    goalNumberOptions.push({
                      value: goal?.goalNumber,
                      label: goal?.goalNumber,
                      disabled: goal.hasOwnProperty("isActive")
                        ? !goal?.isActive
                        : false,
                    });

                    // goal.goalActivities?.map((act) =>
                    //   objectivesMap.push({
                    //     value: act.objectives,
                    //     label: act.objectives,
                    //   })
                    // );

                    // goal.goalActivities?.map((act) =>
                    //   interventionsMap.push({
                    //     value: act.Intervention_Instruction,
                    //     label: act.Intervention_Instruction,
                    //   })
                    // );
                  }
                }
              });
              return v;
            })
        : [];
    } else {
      const filtered = selectedPatient
        ? allPlans
            ?.filter(
              (v) =>
                v?.client?._id === selectedPatient?.id &&
                v?.facility?._id === selectedFacility
            )
            ?.map((v) => {
              v?.outcomes?.map((vv) => {
                // If block is for edit and else block is for add
                if (edit) {
                  // Check if care plan is acive or discontinued
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    // if care plan is active then push all the outcomes
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });

                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        // setEssentialSupport(v?.essentialSupport);
                        setEssentialSupportCount(v?.essentialSupport);
                        // setEssentialAccordion("1");
                      }
                    }
                  } else if (
                    v?.status === "discontinued" &&
                    v?.isActive === false
                  ) {
                    // if care plan is discontinued then check if one of its outcome is used while creating progress note
                    let filteredDesc = data?.data?.descriptions?.filter(
                      (_d) => _d?.outcomeNumber === vv?.id
                    );

                    if (filteredDesc?.length > 0) {
                      // if outcome is used then push the outcome
                      outcomeTitle.push({
                        value: vv?.id,
                        label: `${vv?.outcomeTitle} (D)`,
                        disabled: true,
                      });
                      outcomeNumberArray.push({
                        value: vv?.id,
                        // label: <p>{vv?.outcomeNumber} <b>(D)</b></p>,
                        label: `${vv?.outcomeNumber} (D)`,
                        disabled: true,
                      });
                    }
                  }
                } else {
                  if (
                    v?.status === "active" &&
                    v?.isActive === true &&
                    v?.deleted !== true
                  ) {
                    outcomeTitle.push({
                      value: vv?.id,
                      label: vv?.outcomeTitle,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    outcomeNumberArray.push({
                      value: vv?.id,
                      label: vv?.outcomeNumber,
                      disabled: vv.hasOwnProperty("isActive")
                        ? !vv?.isActive
                        : false,
                    });
                    // If planType is present then save the planId to state for labels
                    if (v?.planType?.planId) {
                      planIdToSave = v?.planType?.planId;
                    }
                    // essential support details
                    if (v?.essentialSupport) {
                      if (v?.essentialSupport?.length > 0) {
                        // setEssentialSupport([v?.essentialSupport[0]]);
                        setEssentialSupportCount(v?.essentialSupport);
                      }
                    }
                    return v;
                  }
                }
              });

              if (
                v?.status === "active" &&
                v?.isActive === true &&
                v?.deleted !== true
              ) {
                v?.essentialSupport?.map((vv) => {
                  essentialSupportArray.push({
                    value: vv?.id,
                    label: vv?.essentialSupportType,
                  });

                  vv?.activities?.map((_a) => {
                    essentialSupportNumber.push({
                      value: _a?.id,
                      label: _a?.supportStatement,
                    });
                  });
                });
              }
            })
        : [];
    }

    setObjectivesByGoal(objectivesMap);
    setInterventionsByGoal(interventionsMap);

    setGoalOptions(goalTitleOptions);
    setGoalNumbers(goalNumberOptions);
    // setGoalActivities(goalActivities

    // Set the planId to the state
    if (planIdToSave) {
      setSavePlanId(planIdToSave);
    }
    setEssentialSupportNumber(essentialSupportNumber);
    setEssentialSupportType(essentialSupportArray);
    setOutComeTitle(outcomeTitle || []);
    setOutComeNumbers(outcomeNumberArray || []);
    if (selectedPatient) {
      let serviceNumber = selectedPatient?.form1?.services?.filter(
        (i) => i?.servicenumber == data?.data?.fields["Service Type"]
      )?.[0];
      setServiceNumber(serviceNumber);
    }
  }, [selectedPatient, allPlans, selectedFacility]);

  // useEffect(() => {
  // }, [selectedFacility]);

  //  useEffect(() => {
  //   if (noteData) {
  //     const allActivities = noteData?.data?.goals?.map((goal) => goal?.goalActivities || []) || [];
  //     setGoalItems(allActivities);
  //   }
  // }, []);

  let getGoalsData = data?.data?.goals;
  // Replace the existing useEffect with this updated version
  useEffect(() => {
    if (noteData) {
      // // Extract goal activities from all goals
      const allActivities =
        noteData?.data?.goals?.flatMap((goal) => goal?.goalActivities || []) ||
        [];

      // // Set goal items for display
      // setGoalItems(allActivities);

      let finalGoalItems = [];

      getGoalsData?.map((_g, index) => {
        finalGoalItems.push(_g.goalActivities);
      });

      setGoalItems(finalGoalItems);

      const formattedObjectives = allActivities?.map((_ga) => ({
        label: _ga.objectives,
        value: _ga.objectives,
      }));

      setObjectivesByGoal(
        formattedObjectives.length > 0 ? formattedObjectives : []
      );

      const formattedInterventions = allActivities?.map((_ga) => ({
        label: _ga.Intervention_Instruction,
        value: _ga.Intervention_Instruction,
      }));

      setInterventionsByGoal(
        formattedInterventions.length > 0 ? formattedInterventions : []
      );
    }
  }, []);

  // // Add New Outcome Handler
  const addDescription = () => {
    if (descriptions?.length < outComeTitle?.length) {
      setDescriptions([
        ...descriptions,
        { id: Date.now(), ...initialDescription },
      ]);
      // setDisplayAccordionTitle(false);
      setOpenedAccordion(`${descriptions?.length}`);
    }
  };

  // // Add New Essential Support Handler
  const addEssentialSupport = () => {
    if (essentialSupport?.length < essentialSupportCount?.length) {
      setEssentialSupport([
        ...essentialSupport,
        {
          id: Date.now(),
          ...initialEssentialSupport,
          // ...essentialSupportCount[essentialSupport?.length],
        },
      ]);
      setEssentialAccordion(`${essentialSupport?.length - 1}`);
    }
  };

  const removeMedication = (medicationId) => {
    setDescriptions(descriptions.filter((med) => med.id !== medicationId));
  };

  // Remove Essential Support Handler
  const removeEssentialSupport = (medicationId) => {
    const filtered = essentialSupport?.filter((med) => {
      return med.id !== medicationId;
    });
    setEssentialSupport(filtered);
  };

  const handleEssentialChange = (supportId, field, value, indexx) => {
    let filtered_plan_1 = allPlans?.filter(
      (v) =>
        v?.client?._id === selectedPatient?.id &&
        v?.facility?._id === selectedFacility
    );

    let selectedEsType = [];
    let selectedActivityId = null;

    filtered_plan_1?.map((_fp) => {
      _fp?.essentialSupport?.map((_es) => {
        if (_es?.activities?.find((_a) => _a?.id == value)) {
          selectedEsType.push(_es);
        }
      });
    });

    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId
            ? { ...selectedEsType?.[0], essentialActivityNumber: value }
            : item;
        } else {
          return item;
        }
      })
    );
  };

  // add note of respective essential plan
  const handleEssentialSupportDesc = (supportId, field, value, indexx) => {
    setEssentialSupport((prev) =>
      prev?.map((item, index) => {
        if (index === indexx) {
          return item.id === supportId ? { ...item, [field]: value } : item;
        } else {
          return item;
        }
      })
    );
  };

  const handleMedicationChange = (medicationId, field, value) => {
    let filteredObj = null;

    if (field === "outcomeTitle") {
      filteredObj = outComeTitle?.filter((item) => item?.value === value)?.[0];
    } else if (field === "outcomeNumber") {
      filteredObj = outcomeNumbers?.filter(
        (item) => item?.value === value
      )?.[0];
    }

    setDisplayAccordionTitle(field);
    let previous = descriptions?.find(
      (v) => v?.outcomeTitle === value || v?.outcomeNumber === value
    );
    let rest = {};
    if (field === "outcomeTitle" || field === "outcomeNumber") {
      let { id, ...others } = allPlans
        ?.find((v) => v?.client?._id === selectedPatient?.id)
        ?.outcomes?.find((v) => v?.id === value);
      rest = others;
    }

    setDescriptions((prevMedications) =>
      prevMedications.map((med, index) => {
        if (field !== "metGoal" && field !== "description") {
          return med.id === medicationId
            ? {
                ...med,
                ...(outcomeNotes[index]?.length > 0 && {
                  description: outcomeNotes[index],
                }),
                [field]: value,
                [field == "outcomeTitle" ? "outcomeNumber" : "outcomeTitle"]:
                  filteredObj?.value,
                outComeCategory:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? allPlans
                        ?.find((v) => v?.client?._id === selectedPatient?.id)
                        ?.outcomes?.find((v) => v?.id === value)
                        ?.outcomeCategory
                    : med?.outComeCategory,
                details:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? filterNonNullFields(rest)
                    : med?.details,
                error: previous ? "Already Selected" : null,
              }
            : med;
        } else {
          return med.id === medicationId
            ? {
                ...med,
                [field]: value,
                outComeCategory:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? allPlans
                        ?.find((v) => v?.client?._id === selectedPatient?.id)
                        ?.outcomes?.find((v) => v?.id === value)
                        ?.outcomeCategory
                    : med?.outComeCategory,
                details:
                  field === "outcomeTitle" || field === "outcomeNumber"
                    ? filterNonNullFields(rest)
                    : med?.details,
                error: previous ? "Already Selected" : null,
              }
            : med;
        }
      })
    );
    setErrors("");
  };

  const handleShowRejection = () => {
    setShowRejection(false);
    setNoteRejectValue(null);
    setNoteRejectionDescp("");
    setReasonError("");
  };

  const resetForm = () => {
    setErrors("");
    form.reset();
    setShowRejectedNote(false);
    setShowApproved(false);
    setShowRejection(false);
    setNoteRejectValue(null);
    setNoteRejectionDescp("");
    setEssentialNotes([]);
    setEssentialSupportToggle(false);
    setEssentialSupport([{ id: 1, ...initialEssentialSupport }]);
    // setNoteType(null);
    setPatientsId(null);
    setSelectedPatient(null);
    close();
  };

  const onSave = (values) => {
    let obj = {
      noteId: NOTETYPE,
      fields: { ...values, noteId: NOTETYPE },
      supportPlan,
      userId,
    };
    const isProgressNote = noteType?.name === "Progress Note";

    if (isProgressNote) obj["descriptions"] = descriptions;

    if (isProgressNote && supportPlan === "yes")
      obj.fields["Description"] = descriptions
        ?.map((rest) => rest?.details?.outcomeTitle)
        ?.join(", ");

    if (edit) {
      let fields = { ...values };
      delete fields["noteId"];
      delete fields["noteType"];
      const obj = {
        ...values,
        id: data?.data?.id,
        fields,
        supportPlan,
        userId,
      };
      if (isProgressNote) obj["descriptions"] = descriptions;

      if (isProgressNote && supportPlan === "yes")
        obj.fields["Description"] = descriptions
          ?.map((rest) => rest?.details?.outcomeTitle)
          ?.join(", ");
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        editNote(obj, false, resetForm);
        setErrors("");
      }
    } else {
      const validations = validateFields();
      if (validations !== true && supportPlan === "yes") {
        validateFields();
      } else {
        createNote(obj, resetForm);
        setErrors("");
      }
    }
  };

  function objectToString(obj) {
    let result = Object.entries(obj)
      .map(
        ([key, value]) =>
          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${`"${
            value || "-"
          }"`}`
      )
      .join("\n");

    return result;
  }

  const arrayToString = (array) => {
    if (array?.length === 0 || array === undefined) return "";
    return array
      ?.filter((v) => v)
      ?.map((v, i) => `${i + 1}) ${v}`)
      .join("\n \n");
  };

  function filterNonNullFields(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== null && value !== undefined && value !== "") {
        result[key] = value;
      }
    }
    return result;
  }

  const handlePatientChange = (patientId, name) => {
    setPatientsId(patientId);
    // setSelectedPatient(allPatients?.find((value) => value?.id === patientId));

    // auto populating facility related to this user...

    !edit && !view && setDescriptions([{ id: 1, ...initialDescription }]);

    form.setFieldValue(name, patientId);
    let facilityExists = noteType?.custom?.find(
      (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
    );
    let patient = allPatients?.find((value) => value?.id === patientId);
    let pcpInfo = {
      "PCP Name": patient?.form2?.["pcpName"],
      "PCP Email": patient?.form2?.["pcpEmail"],
      "PCP Phone Number": patient?.form2?.["pcpPhoneNumber"],
      "PCP Fax Number": patient?.form2?.["pcpFaxNumber"],
    };

    let insuranceDetails = {
      "Insurance Company Name": patient?.form2?.["insuranceCompanyName"],
      "Member Name": patient?.form2?.["memberName"],
      "Member Number": patient?.form2?.["memberNumber"],
      "Prescription Group": patient?.form2?.["prescriptionGroup"],
      "Group Number": patient?.form2?.["groupNumber"],
      "Effective Date": formatDate(patient?.form2?.["effectiveDate"]),
    };
    // form.setFieldValue(facilityExists?.field, patient?.facilityId?.id);
    (edit || view) &&
      form.setFieldValue(
        facilityExists?.field,
        data?.data?.fields?.["Facility Name"]
      );

    form.setFieldValue("All PCP Info", objectToString(pcpInfo));
    form.setFieldValue(
      "Known Allergies",
      arrayToString(patient?.form1?.knownAllergies)
    );
    form.setFieldValue(
      "Dietary Restrictions",
      arrayToString(patient?.form1?.dietaries)
    );

    form.setFieldValue(
      "Known Illnes",
      arrayToString(
        patient?.form1?.knownIllness
          ? patient?.form1?.knownIllness?.map(
              (v) =>
                `${v?.illness || ""} - Contagious: "${v?.contagious || ""}"`
            )
          : []
      ) || "-"
    );
    form.setFieldValue("Insurance Details", objectToString(insuranceDetails));
    form.setFieldValue("Known Wounds", patient?.form1?.woundsInformation);

    form.setFieldValue("Medication Records", "");
    form.setFieldValue("Support Plan", "");
    setMedicationOptions(
      Array.isArray(patient?.form3)
        ? patient?.form3?.map((value) => {
            let { isPrescribed, id, ...rest } = value;
            return {
              label: value?.medicationName,
              value: objectToString({
                ...filterNonNullFields(rest),
                Prescribed: isPrescribed ? "Yes" : "No",
              }),
            };
          })
        : []
    );

    setSupportOptions(
      allPlans
        ?.find((v) => v?.client?.id === patient?.id)
        ?.outcomes?.map(({ id, ...rest }) => ({
          value: objectToString({
            ...filterNonNullFields(rest),
          }),
          label: rest.outcomeTitle,
        })) || []
    );
    if (patient) setSelectedPatient(patient);
  };

  const handleEssentialTypeChangeForNoteView = (value, frequency) => {
    const matchingSupport = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.essentialSupportType === value);
    const formattedFrequency = Array.from(
      new Set(
        matchingSupport
          .map((item) => item?.howOftenEssentialSupport)
          .filter(Boolean)
      )
    ).map((freq) => ({
      label: freq,
      value: freq,
    }));

    // setFrequencyOptions(
    //   formattedFrequency.length > 0 ? formattedFrequency : []
    // );

    // setEssentialSupport()

    const formattedEssentialNumber = Array.from(
      new Set(
        matchingSupport?.map((item) => item?.essentialNumber).filter(Boolean)
      )
    ).map((freq) => ({
      label: freq,
      value: freq,
    }));
    // setEssentialNumber(
    //   formattedEssentialNumber.length > 0 ? formattedEssentialNumber : []
    // );

    const matchingFrequency = allPlans
      ?.filter(
        (v) =>
          v?.client?._id === selectedPatient?.id &&
          v?.facility?._id === selectedFacility &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true
      )
      ?.flatMap((v) => v?.essentialSupport || [])
      ?.filter((_es) => _es?.howOftenEssentialSupport === frequency);

    const matchingSupportType = matchingFrequency?.filter(
      (_es) => _es?.essentialSupportType === value
    );
    // setActivities(matchingSupport?.map((item) => item?.activities).flat());
  };

  useEffect(() => {
    if (!opened) {
      setMedicationOptions([]);
      setSupportOptions([]);
      setDescriptions([{ id: 1, ...initialDescription }]);
      setSupportPlan("no");
      setEssentialSupportToggle("no");
      setDisplayAccordionTitle("");
      form.reset();
    }
    if (noteT && edit) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === noteT?.id),
      };
      let customs = _noteType ? [..._noteType?.custom] : [];
      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
      setSelectedFacility(data?.data?.fields?.["Facility Name"]);
    }
  }, [noteT, opened]);

  useEffect(() => {
    // if (edit) {
    //   if (data?.data?.fields)
    //     Object.entries(data?.data?.fields)?.map((value) => {
    //       if (
    //         `${value[1]}`.split(":")?.length === 3 &&
    //         `${value[1]}`.split("-")?.length === 3
    //       ) {
    //         let date = new Date(value[1]);
    //         form?.setFieldValue(value[0], date);
    //       } else {
    //         form?.setFieldValue(value[0], value[1]);
    //       }
    //     });
    // }

    if (edit) {
      const fields = data?.data?.fields;

      if (fields && typeof fields === "object" && !Array.isArray(fields)) {
        Object.entries(fields)?.map(([key, val]) => {
          if (
            `${val}`.split(":")?.length === 3 &&
            `${val}`.split("-")?.length === 3
          ) {
            const date = new Date(val);
            form?.setFieldValue(key, date);
          } else {
            form?.setFieldValue(key, val);
          }
        });
      } else {
      }
    }

    if (NOTETYPE && opened) {
      form?.setFieldValue(
        "noteType",
        allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE)?.name
      );

      let _noteType = {
        ...allNotesTypes?.ntypes?.find((value) => value?.id === NOTETYPE),
      };
      let customs = _noteType ? [..._noteType?.custom] : [];
      let indexOfPatient = customs.findIndex(
        (v) => v?.field === noteType_Client
      );
      let patientClone = customs[indexOfPatient];
      if (indexOfPatient !== -1) {
        customs.splice(indexOfPatient, 1);
        customs.unshift(patientClone);
        _noteType.custom = customs;
      }
      setNoteType(_noteType);
    }
  }, [NOTETYPE, edit, opened]);

  useEffect(() => {
    if (opened) {
      if (profile?.user?.type === "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else if (profile?.user?.type !== "staff" && !view && !edit) {
        form.setFieldValue("Staff Name", profile?.user?.id);
      } else {
        form.setFieldValue("Staff Name", data?.data?.fields["Staff Name"]);
      }
      let patientType = noteType?.custom?.find(
        (v) => v?.fieldType?.name === noteType_Client_Options
      );
      let patient = allPatients?.find((value) =>
        data?.data?.fields?.["Patient Name"] &&
        !data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Patient Name"]
          : data?.data?.fields?.["Patient Name"] &&
            data?.data?.fields?.["Client Name"]
          ? value?.id === data?.data?.fields["Client Name"]
          : value?.id === data?.data?.fields[patientType?.field]
      );
      if (patient) {
        form.setFieldValue(noteType_Client, patient.id);
        setMedicationOptions(
          Array.isArray(patient?.form3) &&
            patient?.form3?.map((value) => {
              let { isPrescribed, id, ...rest } = value;
              return {
                label: value?.medicationName,
                value: objectToString({
                  ...filterNonNullFields(rest),
                  Prescribed: isPrescribed ? "Yes" : "No",
                }),
              };
            })
        );

        setSupportOptions(
          allPlans
            ?.find((v) => v?.client?.id === patient?.id)
            ?.outcomes?.map(({ id, ...rest }) => ({
              value: objectToString({
                ...filterNonNullFields(rest),
              }),
              label: rest.outcomeTitle,
            })) || []
        );
        setSelectedPatient(patient);
        setDescriptions(data?.data?.descriptions);

        setOutcomeNotes(data?.data?.descriptions?.map((_d) => _d?.description));
        setEssentialNotes(
          data?.data?.essentialSupport?.map((_e) => _e?.description)
        );
        setSupportPlan(data?.data?.supportPlan || "no");
        setEssentialSupportToggle(data?.data?.essentialSupportToggle || "no");
        setInterventionPlanToggle(data?.data?.interventionPlanToggle || "no");
        if (data?.data?.essentialSupport?.length) {
          setEssentialSupport(data?.data?.essentialSupport);
        }
        if (data?.data?.goals?.length) {
          setGoals(data?.data?.goals);
        }
      }
    }
    if (!view)
      noteType?.custom?.forEach((field) => {
        if (field?.fieldType?.name === "date" && !edit) {
          form?.setFieldValue(field.field, new Date());
        }
        if (field?.fieldType?.name === "time" && !edit) {
          const currentTime = new Date().toLocaleTimeString("en-US", {
            hour12: false,
          });
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let hours = new Date().getHours(),
              minutes = new Date().getMinutes();
            form?.setFieldValue(field.field, `${hours}:${minutes}`);
          } else {
            form?.setFieldValue(field.field, currentTime);
          }
        }
      });
  }, [noteType?.custom, opened]);

  useEffect(() => {
    if (userId && !isGroupNote) {
      handlePatientChange(userId, "Client Name");

      // setPatientsId(userId)
      // let patient = allPatients?.find((value) => value?.id === userId);
      // form.setFieldValue(noteType_Client, userId);
      // form.setFieldValue("Patient Name", userId);

      // let facilityExists = noteType?.custom?.find(
      //   (value) => value?.fieldType?.name?.toLowerCase() === "facilities"
      // );

      // form.setFieldValue(facilityExists?.field, patient?.facilityId?.id);
    }
  }, [userId, allPatients]);

  let getEssentialSupport = data?.data?.essentialSupport;

  // useEffect(() => {
  //   if (essentialSupport?.length > 0) {
  //     let data = getEssentialSupport?.[0];

  //     if (opened) {
  //       handleEssentialTypeChangeForNoteView(
  //         data?.essentialSupportType,
  //         data?.howOftenEssentialSupport
  //       );
  //     }

  //     // if (edit === true) {
  //     //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport);
  //     // } else if (view === true) {
  //     //   handleEssentialTypeChangeForNoteView(data?.essentialSupportType, data?.howOftenEssentialSupport);
  //     // }
  //   }
  // }, [opened, essentialSupport]);

  const initialValues = {};

  allNotesTypes?.ntypes?.custom?.map((value) => {
    initialValues[value?.field] = "";
  });

  const form = useForm({
    initialValues: (() => {
      const initialValues = { name: edit ? data?.data?.name : "" };
      // const initialValues = { name: edit ? data?.data?.name : profile?.user?.type === "staff" ? "" : profile?.user?.id };

      noteType?.custom?.forEach((field) => {
        initialValues[field.field] = "";
      });

      return initialValues;
    })(),
    validate: (values) => {
      const errors = {};
      noteType?.custom?.forEach((field) => {
        const fieldName = field.field;

        if (field.fieldType?.name === "number" && isNaN(values[fieldName])) {
          errors[fieldName] = "Must be a number";
        } else if (field.fieldType?.name === "number") {
          errors[fieldName] = null;
        }

        if (!values[fieldName]) {
          if (
            fieldName === "Description" &&
            noteType?.name === "Progress Note"
          ) {
          } else if (fieldName == "Shift") {
          } else {
            errors[fieldName] = "Required";
          }
        }
      });
      return errors;
    },
  });

  const [openedAccordion, setOpenedAccordion] = useState("0");

  const validateFields = () => {
    const newErrors = {};
    descriptions?.forEach((medication, index) => {
      if (!medication?.outcomeNumber) {
        newErrors[index] = "Field is required";
      }
      if (!medication?.outcomeTitle) {
        newErrors[index] = "Field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // outcome fields accordion
  const ReturnFormItem = (data, index, textArea = "") => {
    let { field: name, fieldType, placeholder, options, viewOnly } = data;

    if (
      textArea &&
      supportPlan === "no" &&
      essentialSupportToggle === "no" &&
      interventionPlanToggle === "no" &&
      data?.field === "Description" &&
      (noteType?.name === "Progress Note" ||
        noteType?.id === Essential_Support_Note)
    ) {
      return (
        <Box
          style={{ background: "#fff", padding: "1rem", borderRadius: "10px" }}
        >
          {/* <Radio.Group
            name="useSupportPlan"
            label="Use Support Plan"
            value={supportPlan}
            onChange={setSupportPlan}
            style={{ marginBottom: "20px" }}
          >
            <Group mt="xs">
              <Radio color="yellow" disabled={view} value="yes" label="Yes" />
              <Radio color="yellow" disabled={view} value="no" label="No" />
            </Group>
          </Radio.Group> */}
          <Box className={classes.outcomeContianer}>
            <Text className={classes.outcomeText} mb={3}>
              Note
            </Text>
            <Textarea
              key={index}
              radius="md"
              maxRows={10}
              minRows={5}
              placeholder={placeholder || "Enter text"}
              autosize={view || (viewOnly ? true : false) ? true : false}
              className={`${classes.myfont} ${classes.descriptionText}`}
              {...form.getInputProps(name)}
              readOnly={view || (viewOnly ? true : false)}
              disable={view || (viewOnly ? true : false)}
            />
          </Box>
        </Box>
      );
    }
    if (
      supportPlan === "yes" &&
      (noteType?.name === "Progress Note" ||
        noteType?.custom?.find((_c) => _c?.field === "Support Plan")) &&
      (data?.field === "Description" || data?.field === "Support Plan") &&
      textArea
      // supportPlan === "yes" &&
      // (noteType?.name === "Progress Note" ||
      //   noteType?.custom?.find((_c) => _c?.field === "Support Plan")
      //   //  data?.field === "Support Plan"
      // ) &&
      // // (data?.field === "Description" || data?.field === "Support Plan")
      // textArea
      // // &&
      // // data?.field === "Support Plan"
    ) {
      return (
        <Box style={{ overflowY: "auto", maxHeight: "100%" }}>
          {/* <Box style={{ overflowY: "auto", height: "200px" }}> */}
          {/* <Radio.Group
            name="useSupportPlan"
            label="Use Support Plan"
            value={supportPlan}
            onChange={setSupportPlan}
            style={{ marginBottom: "10px" }}
          >
            <Group mt="xs">
              <Radio color="yellow" disabled={view} value="yes" label="Yes" />
              <Radio color="yellow" disabled={view} value="no" label="No" />
            </Group>
          </Radio.Group> */}
          {/* {supportPlan === "yes" && ( */}
          {
            // supportPlan === "yes" &&
            // (noteType?.name === "Progress Note" ||
            //   noteType?.custom?.find((_c) => _c?.field === "Support Plan"))
            //   &&
            <>
              <Accordion
                value={openedAccordion}
                onChange={setOpenedAccordion}
                chevron={<IconChevronDown size={34} color="#000" />}
                chevronPosition="right"
                chevronSize={34}
                styles={{
                  chevron: {
                    transition: "transform 200ms ease",
                    "&[data-active]": {
                      transform: "rotate(180deg)",
                    },
                  },
                }}
              >
                {descriptions?.map((medication, index) => {
                  const labels = planTypeLabels[medication?.planId];
                  return (
                    <Accordion.Item
                      className={classes.accordionItem}
                      value={`${index}`}
                      style={{
                        marginBottom:
                          index === descriptions?.length - 1 ? "0" : "1rem",
                      }}
                    >
                      <Accordion.Control className={classes.accordionCon}>
                        {(medication?.outcomeNumber === "" ||
                          medication?.outcomeTitle === "") && (
                          <Box className={classes.accordionControl}>
                            <Text variant="text" fw={600}>
                              Outcome
                            </Text>
                            <Text
                              variant="text"
                              color="red"
                              onClick={() => removeMedication(medication.id)}
                            >
                              Delete
                            </Text>
                          </Box>
                        )}
                        {(typeof medication?.outcomeNumber === "number" ||
                          typeof medication?.outcomeTitle === "number") && (
                          <SimpleGrid
                            className={classes.staffContainer}
                            style={{
                              justifyContent:
                                openedAccordion === `${index}`
                                  ? "end"
                                  : "center",
                            }}
                          >
                            {openedAccordion !== `${index}` && (
                              <>
                                <Box
                                  className={classes.staffContainer}
                                  style={{ width: isMobileScreen ? "100%" : "250px" }}
                                >
                                  {/* <Badge color="yellow" size="xl" circle>
                                    {medication?.details?.outcomeNumber}
                                  </Badge> */}
                                  <Text
                                    variant="text"
                                    // className={classes.accordionTitle}
                                    sx={{
                                      minWidth: "150px",
                                      color: "#737373",
                                    }}
                                  >
                                    {medication?.details?.outcomeTitle}
                                  </Text>
                                  <Text variant="text" fw={600}>
                                    {labels?.addNewButtonLabel || ""}{" "}
                                    {medication?.details?.outcomeNumber}
                                  </Text>
                                </Box>
                                {/* <Box
                                  className={classes.staffContainer}
                                  style={{ width: "250px" }}
                                >
                                  <Text variant="text" fw={600}>
                                    Title:
                                  </Text>
                                  <Text
                                    variant="text"
                                    className={classes.accordionTitle}
                                    sx={{ minWidth: "150px" }}
                                  >
                                    {medication?.details?.outcomeTitle}
                                  </Text>
                                </Box>
                                <Box
                                  className={classes.staffContainer}
                                  style={{
                                    width: "500px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Box className={classes.staffContainer}>
                                    <Text variant="text" fw={600}>
                                      {labels?.outcomeCategoryLabel || ""}
                                    </Text>
                                    <Text
                                      variant="text"
                                      className={classes.accordionTitle}
                                      sx={{ minWidth: "200px" }}
                                    >
                                      {medication?.details?.outcomeCategory}
                                    </Text>
                                  </Box>
                                </Box> */}
                              </>
                            )}

                            <Box className={classes.staffContainer}>
                              {!view && (
                                <Text
                                  variant="text"
                                  color="red"
                                  onClick={() =>
                                    removeMedication(medication.id)
                                  }
                                >
                                  Delete
                                </Text>
                              )}
                            </Box>
                          </SimpleGrid>
                        )}
                      </Accordion.Control>
                      <Accordion.Panel>
                        {/* <Group align="center">
                        <Text variant="text" fw={500} mb={15}>
                          Select an Outcome
                        </Text>
                      </Group> */}
                        <Box className={classes.outcomeContianer}>
                          {/* <Text className={classes.outcomeText}>
                          Outcome Title<Text c={"red"}>*</Text>
                        </Text> */}
                          <Text className={classes.outcomeText}>
                            {" "}
                            {medication?.details?.outcomeTitle}
                          </Text>
                          {/* <Text c={"#909296"} ml={10} ff={"inter"}>
                          Outcome Number {medication?.details?.outcomeNumber}
                        </Text> */}
                        </Box>
                        <Divider mt={10} mb={15} />
                        <div key={medication.id}>
                          {view == true ||
                          (edit && !noteData?.data?.planActive === false) ? (
                            <Grid
                              gutter={10}
                              cols={isMobileScreen ? 1 : 3}
                              className={classes.outcomeTitle}
                            >
                              <Grid.Col span={isMobileScreen ? 12 : 4}>
                                <Box className={classes.outcomeContianer}>
                                  <Text c={"#909296"} fw={400} ff={"inter"}>
                                    {/* Outcome Number */}
                                    {labels?.outcomeNumberLabel || ""}
                                  </Text>
                                  <Text className={classes.outcomeText}>
                                    {" "}
                                    {medication?.details?.outcomeNumber}
                                  </Text>
                                </Box>
                              </Grid.Col>
                              {/* <Grid.Col span={isMobileScreen ? 12 : 5}>
                              <Box className={classes.outcomeContianer}>
                                <Text className={classes.outcomeText}>
                                  Outcome Title<Text c={"red"}>*</Text>
                                </Text>
                                <Text c={"#909296"} ff={"inter"}>
                                  {" "}
                                  {medication?.details?.outcomeTitle}
                                </Text>
                              </Box>
                            </Grid.Col> */}
                              <Grid.Col span={isMobileScreen ? 12 : 4}>
                                <Box className={classes.outcomeContianer}>
                                  <Text c={"#909296"} fw={400} ff={"inter"}>
                                    {labels?.outcomeCategoryLabel || ""}
                                  </Text>
                                  <Text className={classes.outcomeText}>
                                    {" "}
                                    {medication?.outComeCategory}
                                  </Text>
                                </Box>
                              </Grid.Col>
                              <Grid.Col span={isMobileScreen ? 12 : 4}>
                                <Box className={classes.outcomeContianer}>
                                  <Text c={"#909296"} fw={400} ff={"inter"}>
                                    Was this goal met
                                  </Text>
                                  <Text className={classes.outcomeText}>
                                    {" "}
                                    {medication?.metGoal}
                                  </Text>
                                </Box>
                              </Grid.Col>
                            </Grid>
                          ) : (
                            <Grid
                              gutter={10}
                              cols={isMobileScreen ? 1 : 3}
                              className={classes.mwd}
                              sx={{
                                paddingBottom: 30,
                              }}
                            >
                              <Grid.Col span={3} xs={12}>
                                <Select
                                  size="sm"
                                  required
                                  id="outcome-number"
                                  data={outcomeNumbers}
                                  label="Outcome Number"
                                  className={classes.selectBG}
                                  placeholder="Select Outcome Number"
                                  value={medication?.outcomeNumber}
                                  onChange={(value) => {
                                    handleMedicationChange(
                                      medication.id,
                                      "outcomeNumber",
                                      value
                                    );
                                  }}
                                  disabled={view}
                                  variant="filled"
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                                {errors[index] && (
                                  <Text color="red" fz={14}>
                                    {errors[index]}
                                  </Text>
                                )}
                              </Grid.Col>
                              <Grid.Col span={5} xs={12}>
                                <Select
                                  required
                                  size="sm"
                                  data={outComeTitle}
                                  label="Outcome Title"
                                  className={classes.selectBG}
                                  placeholder="Select Outcome Title"
                                  value={medication?.outcomeTitle}
                                  onChange={(value) => {
                                    handleMedicationChange(
                                      medication.id,
                                      "outcomeTitle",
                                      value
                                    );
                                  }}
                                  disabled={view}
                                  variant="filled"
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                />
                                {errors[index] && (
                                  <Text color="red" fz={14}>
                                    {errors[index]}
                                  </Text>
                                )}
                              </Grid.Col>
                              <Grid.Col span={4} xs={12}>
                                <TextInput
                                  className={classes.myfont}
                                  label={
                                    <Text className={classes.infoLabel}>
                                      Outcome Category
                                    </Text>
                                  }
                                  size="sm"
                                  placeholder="Enter outcome category"
                                  value={medication?.outComeCategory}
                                  disabled
                                />
                              </Grid.Col>
                            </Grid>
                          )}
                          {/* info accordion */}
                          <ViewInfo data={medication} />
                          <Box className={classes.outcomeContianer}>
                            <Text className={classes.outcomeText}>Note</Text>
                            <Text
                              c={"#909296"}
                              fw={400}
                              ff={"inter"}
                              className={classes.outcomeNote}
                            >
                              {" "}
                              {medication?.description}
                            </Text>
                          </Box>
                          {/* <Box className={classes.textInputBox}>
                          <Text className="label">Add Note //</Text>
                          <Textarea
                            id="add-note"
                            className={`${classes.myfont} ${classes.descriptionText}`}
                            size="sm"
                            maxRows={5}
                            minRows={10}
                            placeholder="Enter Note"
                            value={medication?.description}
                            onChange={(e) => {
                              handleMedicationChange(
                                medication.id,
                                "description",
                                e?.target?.value
                              );
                            }}
                            readOnly={view}
                            autosize={view}
                          />
                        </Box> */}
                          {!view && (
                            <p style={{ color: "red", margin: 0, padding: 0 }}>
                              {medication?.error}
                            </p>
                          )}

                          {/* <Divider my="sm" variant="dashed" /> */}
                        </div>
                        {/* <Select
                        id="about-goal"
                        size="sm"
                        data={[
                          "Yes",
                          "No",
                          "Goal in progress",
                          "Not Applicable",
                        ]}
                        label="Was this goal met?"
                        placeholder="Select a response"
                        value={medication?.metGoal}
                        onChange={(value) => {
                          handleMedicationChange(
                            medication.id,
                            "metGoal",
                            value
                          );
                        }}
                        disabled={view}
                        variant="filled"
                        rightSection={icon}
                        className={classes.select}
                        rightSectionPointerEvents="none"
                      /> */}
                      </Accordion.Panel>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
              {/* {!view && (
                <Button
                  size="sm"
                  m={10}
                  color="yellow"
                  onClick={addDescription}
                  style={{ marginLeft: "auto", display: "block" }}
                >
                  Add New Outcome
                </Button>
              )} */}
            </>
          }
        </Box>
      );
    }
    // field object
    let obj = {
      string: (
        <TextInput
          size="xs"
          id="reason"
          key={index}
          type="text"
          label={name}
          variant="unstyled"
          // variant="filled"
          // className={classes.myfont}
          {...form.getInputProps(name)}
          disabled={view || (viewOnly ? true : false)}
          placeholder={placeholder || `Enter response`}
        />
      ),
      "text area": (
        <Box
          className={classes.outcomeContianer}
          style={{ height: "100px !important" }}
        >
          <Text htmlFor={name} className={classes.outcomeText}>
            {name}
          </Text>

          <Textarea
            id={
              data?.field === "Description"
                ? "enter-description"
                : data?.field === "Medication"
                ? "enter-medication"
                : "enter-note"
            }
            key={index}
            // radius="xs"
            minRows={view || (viewOnly ? true : false) ? 5 : 10}
            maxRows={view || (viewOnly ? true : false) ? 5 : 10}
            autosize={view || (viewOnly ? true : false) ? true : false}
            placeholder={placeholder || `Enter response`}
            className={`${classes.myfont} ${classes.descriptionText} ${
              view || (viewOnly ? true : false) ? classes.disabledTextarea : ""
            }`}
            style={{ height: "500px !important" }}
            {...form.getInputProps(name)}
            readOnly={view || viewOnly ? true : false}
          />
        </Box>
      ),

      number: (
        <Flex direction={"column"}>
          {view ? (
            <TextInput
              readOnly
              key={index}
              type="number"
              variant="unstyled"
              {...form.getInputProps(name)}
              className={`${classes.timeDateView} ${classes.fontSizeClass}`}
              label={
                <Text ff={"Inter"} fz={16} fw={500} color="#737373">
                  {name}
                </Text>
              }
            />
          ) : (
            <TextInput
              size="xs"
              key={index}
              label={name}
              type="number"
              variant="filled"
              className={classes.selectBG}
              {...form.getInputProps(name)}
              disabled={view || (viewOnly ? true : false) || !serviceNumber}
              placeholder={placeholder || `Enter response`}
            />
          )}
          {isBilling_Services && (
            <Text fz={12} fs="italic" c={"#ccc"}>
              Approved Units: {serviceNumber?.servicenumber}
            </Text>
          )}
        </Flex>
      ),

      time: (
        <Box>
          {view ? (
            <TimeInput
              readOnly={view}
              key={index}
              ref={ref}
              variant="unstyled"
              placeholder={`Select ${name}`}
              className={`${classes.timeDateView} ${classes.fontSizeClass}`}
              {...form.getInputProps(name)}
              label={name}
            />
          ) : (
            <TimeInput
              label={name}
              variant="unstyled"
              key={index}
              ref={ref}
              size="xs"
              placeholder={`Select ${name}`}
              className={classes.myfont}
              rightSection={
                <ActionIcon onClick={() => ref?.current?.showPicker()}>
                  <IconClock size="1rem" stroke={1.5} />
                </ActionIcon>
              }
              {...form.getInputProps(name)}
              onChange={(e) => {
                const isSafari = /^((?!chrome|android).)*safari/i.test(
                  navigator.userAgent
                );
                const datetime = new Date(e?.target?.value).toLocaleTimeString(
                  "en-US",
                  { hour12: false }
                );
                let time = e.target.value?.split(":")?.slice(0, 2)?.join(":");
                isSafari
                  ? form.setFieldValue(name, time)
                  : form.setFieldValue(name, e?.target?.value);
              }}
              disabled={view || (viewOnly ? true : false)}
              style={{ borderBottom: "2px solid #aaaaaa" }}
            />
          )}
        </Box>
      ),
      date: (
        <Box>
          {view ? (
            <DateInput
              size="md"
              readOnly
              key={index}
              id="date-click"
              variant="unstyled"
              className={`${classes.timeDateView} ${classes.fontSizeClass}`}
              {...form.getInputProps(name)}
              placeholder={`Select ${name}`}
              label={name}
            />
          ) : (
            <DateInput
              size="xs"
              key={index}
              label={name}
              id="date-click"
              variant="unstyled"
              className={classes.myfont}
              {...form.getInputProps(name)}
              placeholder={`Select ${name}`}
              disabled={view || (viewOnly ? true : false)}
              style={{ borderBottom: "2px solid #aaaaaa" }}
              rightSection={
                <img
                  style={{ width: "30px" }}
                  src={"/assets/images/calendar-icon.png"}
                  alt="Icon"
                />
              }
            />
          )}
        </Box>
      ),
      Clients: (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          defaultValue={userId}
          id={"client-name-note"}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          data={getOptions(noteType_Client_Options, noteType?.custom)}
          disabled={view || edit || (viewOnly || userId ? true : false)}
        />
      ),
      Provider: (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          // defaultValue={userId}
          id={"client-name-note"}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          // required={viewOnly || userId ? false : true}
          onChange={(v) => handlePatientChange(v, name)}
          value={selectedPatient?.providerId?.[0]?.id || ""}
          data={
            selectedPatient?.providerId?.length > 0
              ? selectedPatient?.providerId?.map((_p) => ({
                  value: _p?.id,
                  label: _p?.name,
                }))
              : []
          }
          disabled={true}
        />
      ),

      Facilities: view ? (
        <Select
          readOnly
          size="md"
          searchable
          variant="unstyled"
          {...form.getInputProps(name)}
          className={`${classes.timeDateView} ${classes.fontSizeClass}`}
          data={
            isGroupNote
              ? getOptions("Facilities", noteType?.custom)
              : getOptions("Facilities", noteType?.custom)?.filter((opt) => {
                  if (Array.isArray(selectedPatient?.facilityId)) {
                    return !!selectedPatient?.facilityId?.find(
                      (fac) => fac?.id == opt?.value
                    );
                  } else {
                    return selectedPatient?.facilityId?.id == opt?.value;
                  }
                })
          }
          label={
            <Text ff={"Inter"} fz={16} fw={500} color="#737373">
              {name}
            </Text>
          }
        />
      ) : (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.selectBG}
          {...form.getInputProps(name)}
          placeholder={`Select ${name} XX`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          required={viewOnly || userId ? false : true}
          // data={getOptions("Facilities", noteType?.custom)}
          data={getOptions("Facilities", noteType?.custom)?.filter((opt) => {
            if (Array.isArray(selectedPatient?.facilityId)) {
              if (
                selectedPatient?.facilityId?.find(
                  (fac) => fac?.id == opt?.value
                )
              ) {
                return opt;
              }
            } else {
              if (selectedPatient?.facilityId?.id == opt?.value) {
                return opt;
              }
            }
          })}
          // selectedPatient
        />
      ),
      Staff: (
        <Box className={classes.staffField}>
          <Text ff={"Inter"} fz={12} fw={500} color="#737373">
            {name}
          </Text>
          {view ? (
            <Text ff={"Inter"} fz={20} fw={700}>
              {getOptions("Staff", noteType?.custom)?.find(
                (option) => option.value === form?.getInputProps(name)?.value
              )?.label || "Select a Staff"}
            </Text>
          ) : (
            <Select
              w={isMobileScreen ? "100%" : 250}
              size="md"
              variant="filled"
              rightSectionPointerEvents="none"
              data={getOptions("Staff", noteType?.custom)}
              placeholder={`Select ${name}`}
              searchable
              defaultValue={form?.getInputProps(name)}
              className={classes.myfont}
              {...form.getInputProps(name)}
              disabled={
                view ||
                (viewOnly
                  ? true
                  : !edit && profile?.user?.type === "staff"
                  ? true
                  : false)
              }
            />
          )}
        </Box>
      ),
      "Facility Types": (
        <Select
          size="xs"
          searchable
          label={name}
          variant="filled"
          rightSection={icon}
          className={classes.myfont}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("Facility Types", noteType?.custom)}
        />
      ),
      Other: (
        <Box>
          {view ? (
            <Select
              readOnly
              size="md"
              searchable
              id="enter-shift"
              variant="unstyled"
              {...form.getInputProps(name)}
              className={`${classes.timeDateView} ${classes.fontSizeClass}`}
              placeholder={"None"}
              data={getOptions("Other", noteType?.custom, name)}
              label={
                <Text ff={"Inter"} fz={16} fw={500} color="#737373">
                  {name}
                </Text>
              }
              required={data?.field?.toLowerCase() == "shift" ? false : true}
              // rightSection={icon}
              // rightSectionPointerEvents="none"
              // disabled={view || (viewOnly ? true : false)}
            />
          ) : (
            <Select
              size="xs"
              required={data?.field?.toLowerCase() == "shift" ? false : true}
              searchable
              label={name}
              id="enter-shift"
              variant="filled"
              rightSection={icon}
              className={classes.selectBG}
              {...form.getInputProps(name)}
              placeholder={`Select ${name}`}
              rightSectionPointerEvents="none"
              disabled={view || (viewOnly ? true : false)}
              data={getOptions("Other", noteType?.custom, name)}
            />
          )}
        </Box>
      ),
      "Multiple Choice": (
        <Checkbox.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("multiple choices", noteType?.custom, name)?.map(
            (option) => (
              <Checkbox
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                disabled={view || (viewOnly ? true : false)}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Checkbox.Group>
      ),
      "Single Choice": (
        <Radio.Group
          label={name}
          id="enter-shift"
          required={data?.field?.toLowerCase() === "shift" ? false : true}
          {...form.getInputProps(name)}
        >
          {getOptions("single choice", noteType?.custom, name)?.map(
            (option) => (
              <Radio
                disabled={view || (viewOnly ? true : false)}
                color="gray"
                key={option?.value}
                value={option?.value}
                label={option?.label}
                mt={index === 0 ? "10px" : "10px"}
              />
            )
          )}
        </Radio.Group>
      ),
      Dropdown: view ? (
        <Select
          readOnly
          size="md"
          searchable
          variant="unstyled"
          id="enter-shift"
          {...form.getInputProps(name)}
          className={`${classes.timeDateView} ${classes.fontSizeClass}`}
          placeholder={"None"}
          data={getOptions("dropdown", noteType?.custom, name)}
          label={
            <Text ff={"Inter"} fz={16} fw={500} color="#737373">
              {name}
            </Text>
          }
        />
      ) : (
        <Select
          size="md"
          radius="md"
          required={data?.field?.toLowerCase() == "shift" ? false : true}
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("dropdown", noteType?.custom, name)}
        />
      ),
      "Medication Records": (
        <Group align="flex-end">
          <Select
            size="xs"
            searchable
            label={name}
            data={medicationOptions}
            className={classes.myfont}
            {...form.getInputProps(name)}
            placeholder={`Select ${name}`}
            disabled={view || (viewOnly ? true : false)}
            icon={<img src="/assets/images/home2.png" alt="home" />}
          />
          <Popover
            shadow="md"
            width={300}
            position="bottom-end"
            style={{ marginBottom: "10px" }}
          >
            <Popover.Target>
              <IconInfoCircle
                color="gray"
                styles={{ marginTop: "30px !important" }}
              />
            </Popover.Target>
            <Popover.Dropdown sx={{ pointerEvents: "none" }}>
              <Textarea
                key={`${index}-test`}
                radius="md"
                autosize={true}
                icon={
                  <img
                    className={classes.descriptionIcon}
                    src="/assets/images/home2.png"
                    alt="home"
                  />
                }
                placeholder={
                  placeholder || `Select ${name} to see details here.`
                }
                className={`${classes.myfont} ${classes.descriptionText}`}
                style={{ height: "200px !important", marginTop: "10px" }}
                value={form.values[name]}
                disabled={true}
              />
            </Popover.Dropdown>
          </Popover>
        </Group>
      ),
      "level of need": (
        <Select
          size="md"
          radius="md"
          searchable
          className={classes.select}
          label={name}
          id="enter-shift"
          rightSection={icon}
          {...form.getInputProps(name)}
          placeholder={`Select ${name}`}
          rightSectionPointerEvents="none"
          disabled={view || (viewOnly ? true : false)}
          data={getOptions("level of need", noteType?.custom)}
        />
      ),
      // "Support Plan": (
      //   <Group align="flex-end">
      //     <Select
      //       size="xs"
      //       searchable
      //       label={name}
      //       data={supportOptions}
      //       className={classes.myfont}
      //       {...form.getInputProps(name)}
      //       placeholder={`Select ${name}`}
      //       disabled={view || (viewOnly ? true : false)}
      //       icon={<img src="/assets/images/home2.png" alt="home" />}
      //     />
      //     <Popover
      //       width={300}
      //       shadow="md"
      //       position="bottom-end"
      //       style={{ marginBottom: "10px" }}
      //     >
      //       <Popover.Target>
      //         <IconInfoCircle
      //           color="gray"
      //           styles={{ marginTop: "30px !important" }}
      //         />
      //       </Popover.Target>
      //       <Popover.Dropdown sx={{ pointerEvents: "none" }}>
      //         <Textarea
      //           key={`${index}-test`}
      //           radius="md"
      //           autosize={true}
      //           icon={
      //             <img
      //               className={classes.descriptionIcon}
      //               src="/assets/images/home2.png"
      //               alt="home"
      //             />
      //           }
      //           placeholder={
      //             placeholder || `Select ${name} to see details here.`
      //           }
      //           className={`${classes.myfont} ${classes.descriptionText}`}
      //           // style={{ height: "200px !important", marginTop: "10px" }}
      //           style={{ height: "200px !important", marginTop: "10px" }}
      //           value={form.values[name]}
      //           disabled={true}
      //         />
      //       </Popover.Dropdown>
      //     </Popover>
      //   </Group>
      // ),
    };
    if (
      (essentialSupportToggle === "yes" || interventionPlanToggle === "yes") &&
      name === "Description" &&
      textArea
    )
      return null;
    else if (!textArea && fieldType?.name != "text area") {
      return obj[fieldType?.name];
    } else if (textArea && fieldType?.name === "text area")
      return obj[fieldType?.name];
    else return null;
  };

  //    const [matchedActivity, setMatchedActivity] = useState(null);

  //    useEffect(() => {
  //   if (view === true && data?.data?.essentialSupport?.length > 0) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     const matchedActivities = getEssentialSupport.map((es) =>
  //       es?.activities?.find(
  //         (activity) => activity?.id === es?.essentialActivityNumber
  //       )
  //     );

  //     setMatchedActivity(matchedActivities);

  //     // If you're storing combined support + activities in a new state
  //     setEssentialSupport({
  //       ...getEssentialSupport,
  //       activities: matchedActivities,
  //     });
  //   }
  // }, [view, data?.data?.essentialSupport]);

  // useEffect(() => {
  //   if (essentialSupport && essentialSupport.length > 0 && view === true) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     const matchedActivities = getEssentialSupport?.map((es) =>
  //       es?.activities?.find(
  //         (activity) => activity?.id === es?.essentialActivityNumber
  //       )
  //     );

  //     setMatchedActivity(matchedActivities);
  //     // setEssentialSupport(matchedActivities);
  //         setEssentialSupport((prev) =>
  //         {...prev,
  //           activities: matchedActivities,
  //         }
  //       );
  //   }
  // }, [essentialSupport, view]);

  // useEffect(() => {
  //   if (essentialSupport && essentialSupport.length > 0 && view === true) {
  //     const getEssentialSupport = data?.data?.essentialSupport;

  //     ;const matchedActivity = getEssentialSupport?.map((es) => es?.activities.find(
  //       (activity) => activity.id === getEssentialSupport?.essentialActivityNumber
  //     ));

  //     setMatchedActivity(matchedActivity);

  //     // if (matchedActivity) {

  //     //   // example: use matchedActivity data
  //     //   handleEssentialTypeChangeForNoteView(
  //     //     data.essentialSupportType,
  //     //     data.howOftenEssentialSupport,
  //     //     matchedActivity
  //     //   );
  //     // }
  //   }
  // }, [essentialSupport, view])

  const showRadioButtons =
    (noteType?.name === "Incident Note" &&
      noteType?.name === "Medication Note") ||
    noteType?.name === "Progress Note" ||
    noteType?.custom?.find((_c) => _c?.field === "Support Plan");

  const isEssentialSupportNote = noteType?.id === Essential_Support_Note;
  const isInterventionProgressNote =
    noteType?.id === Intervention_Progress_Note;
  const hasSupportPlan = noteType?.custom?.some(
    (_c) => _c?.field === "Support Plan"
  );

  const handleToggleChange = (e) => {
    setEssentialSupportToggle(e);
  };

  const handleReject = async () => {
    if (!noteRejectValue) {
      // Set an error message to be displayed on the screen
      setReasonError("Reason field is required");
      return;
    }

    try {
      const rejectionData = {
        noteId: noteData?.data?.id,
        approvalStatus: "rejected",
        rejectionReason: noteRejectValue,
        rejectionDescriptions: noteRejectionDescp,
      };
      const response = await updateNoteStatus(rejectionData);
      if (response?.status === 200) {
        setShowRejectedNote(false);
        setShowRejection(false);
        setShowApproved(false);
        setNoteRejectValue(null);
        setNoteRejectionDescp(null);
        getTodaysNotes("");
        // getPendingNotes();
        getPendingActions()
        close();
      }
    } catch (error) {}
  };

  const handleApprove = async () => {
    try {
      const approvedData = {
        noteId: noteData?.data?.id,
        approvalStatus: "approved",
      };
      const response = await updateNoteStatus(approvedData);
      if (response?.status === 200) {
        getTodaysNotes("");
        // getPendingNotes();
        getPendingActions()
        close();
        setShowApproved(false);
      }
    } catch (error) {}
  };

  const headerStyle =
    noteData?.data?.approvalStatus === "approved"
      ? classes.approved
      : noteData?.data?.approvalStatus === "rejected"
      ? classes.rejected
      : classes.pending;

  return (
    <>
      {/* <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "1000px" }}> */}
      <Drawer
        position="right"
        radius={isMobileScreen ? 0 : 16}
        offset={isMobileScreen ? 0 : 10}
        shadow="md"
        size={isMobileScreen ? "100%" : 800}
        zIndex={2100}
        opened={opened}
        overlayProps={{ blur: 1 }}
        className={classes.noteViewNewDrawer}
        scrollAreaComponent={ScrollArea}
        withCloseButton={false}
        onClose={() => {
          resetForm();
          setNoteRejectValue(null);
          setNoteRejectionDescp("");
          setOpenedAccordion("0");
          setView(false);
        }}
      >
        <Group position="apart" p="13px 19px" className={cx(headerStyle)}>
          <Text variant="text" fw={700} fz={24} ff="Inter">
            <span>{view ? "View" : edit ? "Edit" : "Add New"}</span>{" "}
            <span>{noteType?.name}</span>
          </Text>
          <Button variant="unstyled" onClick={close} p="0px">
            <RxCross1 size={20} />
          </Button>
        </Group>

        <form
          onSubmit={form?.onSubmit((values) => onSave(values))}
          style={{
            background: "#f5f5f5",
            padding: isMobileScreen ? "8px 12px" : "8px 24px",
            height: "100%",
            // overflow: "scroll",
          }}
        >
          <SimpleGrid cols={1}>
            {noteType?.custom?.map((value, index) => {
              if (value.field !== "Staff Name") return null;

              const selectedValue = form?.getInputProps(value?.field)?.value;

              // Staff options me se selected staff ka value
              const selectedOption = getOptions(
                "Staff",
                noteType?.custom
              )?.find((option) => option.value === selectedValue)?.value;

              // Matching signature object
              const signatureData = allSignature?.find(
                ({ staff, admin }) =>
                  (staff && staff === selectedOption) || (admin && admin === selectedOption)
              );

              const signatureImage =
                signatureData?.signature || signatureData?.signatureImage;
              const signatureText = signatureData?.signatureText;

              return (
                <React.Fragment key={index}>
                  <Flex justify="space-between" align="flex-start">
                    {ReturnFormItem(value, index)}
                    {signatureImage ? (
                      <Flex justify="flex-end">
                        <img
                          src={decrypt(signatureImage)}
                          alt="signature"
                          className={classes.signatureImg}
                        />
                      </Flex>
                    ) : signatureText ? (
                      <Flex justify="flex-end">
                        <Text
                          fz={32}
                          fw={400}
                          ff="Island Moments"
                          color="#171717"
                        >
                          {signatureText}
                        </Text>
                      </Flex>
                    ) : null}
                  </Flex>
                </React.Fragment>
              );
            })}
          </SimpleGrid>

          <Box
            className={classes.modalContentBG}
            sx={{
              padding: "1rem",
              background: "#fff",
              border: "1px solid #E5E5EA",
            }}
          >
            <Box className={classes.modalTopHeader}>
              {isGroupNote ? (
                groupClients?.length > 0 && (
                  <Flex gap={16} wrap="wrap">
                    {groupClients.map((p) => (
                      <Box key={p?.id} className={classes.userDetails}>
                        <Avatar
                          size={50}
                          radius={50}
                          shape="circle"
                          src={
                            p?.imageurl
                              ? decrypt(p?.imageurl)
                              : "/assets/images/personal2.png"
                          }
                        />
                        <Box className={classes.userInfo}>
                          <Text variant="text" c={"#737373"} fw={400} fz={12}>
                            Client name
                          </Text>
                          <Text variant="text" fz={16} fw={600} ff={"Inter"}>
                            {p?.name}
                          </Text>
                          <Text variant="text" fz={14} fw={500} c={"#737373"} ff={"Inter"}>
                            {String(p?.id)?.slice(-6)}
                          </Text>
                        </Box>
                      </Box>
                    ))}
                  </Flex>
                )
              ) : (
                (view || selectedPatient || edit || patientsId) && (
                  <Box className={classes.userDetails}>
                    <Avatar
                      size={50}
                      radius={50}
                      shape="circle"
                      src={
                        selectedPatient?.imageurl
                          ? decrypt(selectedPatient?.imageurl)
                          : "/assets/images/personal2.png"
                      }
                    />
                    <Box className={classes.userInfo}>
                      <Text variant="text" c={"#737373"} fw={400} fz={12}>
                        Client name
                      </Text>
                      <Text variant="text" fz={16} fw={600} ff={"Inter"}>
                        {selectedPatient?.name}
                      </Text>
                      <Text
                        variant="text"
                        fz={14}
                        fw={500}
                        c={"#737373"}
                        ff={"Inter"}
                      >
                        {clientId}
                      </Text>
                    </Box>
                  </Box>
                )
              )}
            </Box>
            <Divider my="md" />
            <Box className={classes.bottomFields}>
              <SimpleGrid className={classes.mwd} cols={isMobileScreen ? 1 : 4}>
                {noteType?.custom?.map((value, index) =>
                  value.field !== "Staff Name" &&
                  value.field !== "Client Name" &&
                  value.field !== "Level of Need"
                    ? ReturnFormItem(value, index)
                    : null
                )}
                {isInterventionProgressNote ? (
                  // Intervention Progress Note Display
                  <Box className={classes.supportPlan}>
                    {view ? (
                      <>
                        <Text
                          ff={"Inter"}
                          fz={12}
                          fw={400}
                          ta="start"
                          color="#737373"
                          w={180}
                        >
                          Intervention Plan
                        </Text>
                        <Text
                          ff={"Inter"}
                          color="#262626"
                          fz={14}
                          ta="start"
                          fw={600}
                          tt={"capitalize"}
                        >
                          {interventionPlanToggle}
                        </Text>
                      </>
                    ) : (
                      <Radio.Group
                        size="xs"
                        value={interventionPlanToggle}
                        name="useInterventionPlan"
                        label="Use Intervention Plan"
                        onChange={setInterventionPlanToggle}
                        style={{ marginBottom: "10px" }}
                      >
                        <Group mt="xs">
                          <Radio
                            value="yes"
                            label="Yes"
                            color="yellow"
                            disabled={view}
                          />
                          <Radio
                            value="no"
                            label="No"
                            color="yellow"
                            disabled={view}
                          />
                        </Group>
                      </Radio.Group>
                    )}
                  </Box>
                ) : isEssentialSupportNote ? (
                  // Essential Support Note Display
                  <Box className={classes.supportPlan}>
                    {view ? (
                      <>
                        <Text
                          ff={"Inter"}
                          fz={12}
                          fw={400}
                          ta="start"
                          color="#737373"
                          w={180}
                        >
                          Essential Support Plan
                        </Text>
                        <Text
                          ff={"Inter"}
                          color="#262626"
                          fz={14}
                          ta="start"
                          fw={600}
                          tt={"capitalize"}
                        >
                          {essentialSupportToggle}
                        </Text>
                      </>
                    ) : (
                      // Add your Essential Support Note input/edit component here
                      <Radio.Group
                        size="xs"
                        value={essentialSupportToggle}
                        name="useSupportPlan"
                        label="Use Essential Support"
                        onChange={handleToggleChange}
                        style={{ marginBottom: "10px" }}
                      >
                        <Group mt="xs">
                          <Radio
                            value="yes"
                            label="Yes"
                            id="check-yes"
                            color="yellow"
                            disabled={view}
                          />
                          <Radio
                            value="no"
                            label="No"
                            color="yellow"
                            disabled={view}
                          />
                        </Group>
                      </Radio.Group>
                    )}
                  </Box>
                ) : // Original Support Plan Radio/View
                view ? (
                  <Box className={classes.supportPlan}>
                    {hasSupportPlan && (
                      <>
                        <Text ff={"Inter"} fz={16} fw={500} color="#737373">
                          Support Plan
                        </Text>
                        <Text ff={"Inter"} fz={16} fw={600} tt={"capitalize"}>
                          {supportPlan}
                        </Text>
                      </>
                    )}
                  </Box>
                ) : (
                  <Radio.Group
                    size="xs"
                    value={supportPlan}
                    name="useSupportPlan"
                    label="Support Plan"
                    onChange={setSupportPlan}
                    style={{ marginBottom: "10px" }}
                  >
                    <Group mt="xs">
                      <Radio
                        value="yes"
                        label="Yes"
                        id="check-yes"
                        color="yellow"
                        disabled={view}
                      />
                      <Radio
                        value="no"
                        label="No"
                        color="yellow"
                        disabled={view}
                      />
                    </Group>
                  </Radio.Group>
                )}
              </SimpleGrid>
              {isBilling_Services && (
                <SimpleGrid cols={isMobileScreen ? 1 : 4} mt={10}>
                  <Select
                    size="xs"
                    searchable
                    label={"Service (Unit Type: Days)"}
                    variant="filled"
                    rightSection={icon}
                    // defaultValue={userId}
                    id={"client-name-note"}
                    className={classes.selectBG}
                    {...form.getInputProps("Service Type")}
                    placeholder={`Select Service (Unit Type: Days)`}
                    rightSectionPointerEvents="none"
                    required={view || userId ? false : true}
                    onChange={(v) => {
                      handlePatientChange(v, "Service Type");
                    }}
                    data={
                      selectedPatient
                        ? selectedPatient?.form1?.services?.map((val) => ({
                            value: val?.servicenumber,
                            label: val?.servicetitle,
                          }))
                        : []
                    }
                    disabled={view}
                  />
                </SimpleGrid>
              )}
            </Box>
          </Box>
          <Text pt={"24px"} ff={"Inter"} fz={14} fw={500} color="#262626">
            Details
          </Text>

          <Box
            className={classes.modalContentBG}
            style={{
              overflowY:
                noteType?.name !== "Progress Note" ? "auto" : "visible",
              maxHeight: noteType?.name !== "Progress Note" ? "100%" : "auto",
              height: noteType?.name !== "Progress Note" ? "100%" : "auto",
              marginTop: "0.5rem",
            }}
          >
            {/* -----> Level of need <----- */}
            {noteType?.custom?.filter(
              (value) => value?.field === "Level of Need"
            ) &&
              noteType?.custom
                ?.filter((value) => value.field === "Level of Need")
                .map((value, index) => (
                  <Box mb={10}>{ReturnFormItem(value, index)}</Box>
                ))}

            <SimpleGrid cols={1} className={classes.mwd}>
              {noteType?.custom?.map((value, index) =>
                ReturnFormItem(value, index, "text area")
              )}
            </SimpleGrid>
          </Box>

          {!view && supportPlan === "yes" && (
            <Button
              m={10}
              size="sm"
              radius={8}
              color="yellow"
              onClick={addDescription}
              style={{
                marginLeft: "auto",
                display: "block",
              }}
            >
              <Text c="#000">Add New Outcome</Text>
            </Button>
          )}

          {essentialSupportToggle === "yes" && (
            <Box style={{ overflowY: "auto", maxHeight: "100%" }}>
              <Accordion
                value={essentialAccordion}
                onChange={setEssentialAccordion}
                mx={10}
                variant="separated"
                chevron={<IconChevronDown size={34} color="gray" />}
                chevronPosition="right"
                chevronSize={34}
                styles={{
                  chevron: {
                    transition: "transform 200ms ease",
                    "&[data-active]": {
                      transform: "rotate(180deg)",
                    },
                  },
                }}
              >
                {Array.isArray(essentialSupport) &&
                  essentialSupport?.map((support, index) => (
                    <Accordion.Item
                      key={support?.id}
                      value={String(index)}
                      className={classes.accordionItem}
                    >
                      <Accordion.Control>
                        <Box className={classes.accordionControl}>
                          <Text>
                            Essential Support #
                            {support?.essentialNumber || index + 1}
                          </Text>
                          {!view && (
                            <Text
                              variant="text"
                              color="red"
                              onClick={() =>
                                removeEssentialSupport(support?.id)
                              }
                            >
                              Delete
                            </Text>
                          )}
                        </Box>
                      </Accordion.Control>

                      <Accordion.Panel>
                        <Grid
                          gutter={10}
                          // cols={isMobileScreen ? 1 : 3}
                          className={classes.mwd}
                          sx={{
                            paddingBottom: 30,
                          }}
                        >
                          <Grid.Col span={isMobileScreen ? 12 : 5}>
                            {/* <Select
                              id="essential-support-type"
                              size="sm"
                              required
                              data={essentialSupportType}
                              label={"Essential Support Type"}
                              className={classes.select}
                              placeholder={"Select Type"}
                              value={support?.essentialSupportType || ""}
                              disabled={true}
                              // variant="filled"
                              rightSectionPointerEvents="none"
                              rightSection={icon}
                            />
                            <Box>{support?.essentialSupportType || ""}</Box> */}
                            <TextInput
                              id="essential-support-type"
                              disabled
                              size="sm"
                              label={"Essential Support Type"}
                              value={support?.essentialSupportType || ""}
                              className={classes.input}
                              placeholder={"#"}
                              variant="filled"
                              withAsterisk={false}
                            />
                          </Grid.Col>
                          <Grid.Col span={isMobileScreen ? 12 : 5}>
                            {/* <Select
                              id="essential-support-frequency"
                              size="sm"
                              required
                              data={[]}
                              label={"Frequency"}
                              className={classes.select}
                              placeholder={"Select Frequency"}
                              value={support?.howOftenEssentialSupport || ""} // ✅ set value
                              readOnly={view}
                              variant="filled"
                              mx={{ base: 0, sm: 10 }}
                              my={{ base: 26, sm: 0 }}
                              withAsterisk={false}
                              rightSectionPointerEvents="none"
                              rightSection={icon}
                              disabled
                            /> */}
                            <TextInput
                              id="essential-support-frequency"
                              disabled
                              size="sm"
                              label={"Frequency"}
                              value={support?.howOftenEssentialSupport || ""}
                              className={classes.input}
                              placeholder={"Frequency"}
                              variant="filled"
                              withAsterisk={false}
                            />
                          </Grid.Col>
                          <Grid.Col span={isMobileScreen ? 12 : 2}>
                            <TextInput
                              id="essential-support-type"
                              disabled
                              size="sm"
                              label={"Outcome #"}
                              value={support?.essentialNumber || index + 1}
                              className={classes.input}
                              placeholder={"#"}
                              variant="filled"
                              withAsterisk={false}
                            />
                          </Grid.Col>
                        </Grid>
                        <Grid mb={10}>
                          <Grid.Col span={12}>
                            <TextInput
                              id="essential-support-activities"
                              disabled
                              size="sm"
                              label={"Essential Support Activities"}
                              value={
                                support?.activities
                                  ?.filter(
                                    (_a) =>
                                      _a?.id ===
                                      support?.essentialActivityNumber
                                  )
                                  ?.map((a) => a?.supportStatement)[0] || ""
                              }
                              className={classes.input}
                              placeholder={"#"}
                              variant="filled"
                              withAsterisk={false}
                            />
                          </Grid.Col>
                        </Grid>
                        <EssentialViewInfo data={support} />
                        <Box className={classes.outcomeContianer}>
                          <Text className={classes.outcomeText}>Note</Text>
                          <Text
                            c={"#909296"}
                            fw={400}
                            ff={"inter"}
                            className={classes.outcomeNote}
                          >
                            {" "}
                            {support?.description?.length > 0
                              ? support?.description
                              : essentialNotes[index]}
                          </Text>
                        </Box>
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </Box>
          )}

          {!view && essentialSupportToggle === "yes" && (
            <Button
              m={10}
              size="sm"
              radius={8}
              color="yellow"
              onClick={addEssentialSupport}
              className={`${classes.responsiveBtn}`}
              style={{
                marginLeft: "auto",
                display: "block",
                marginTop: "10px",
              }}
            >
              <Text c="#000">Add New Support Activity</Text>
            </Button>
          )}
          {interventionPlanToggle === "yes" && (
            <Box>
              <Accordion
                value={goalsAccordion}
                onChange={(value) => {
                  // if (view === true || edit === true) {
                  //   let data = essentialSupport?.[value];
                  //   handleEssentialTypeChangeForNoteView(
                  //     data?.essentialSupportType,
                  //     data?.howOftenEssentialSupport
                  //   );
                  // }
                  setGoalsAccordion(value);
                }}
                mt={16}
                variant="separated"
                chevron={<IconChevronDown size={34} color="#000000" />}
                chevronPosition="right"
                chevronSize={20}
                className={classes.essentialAccordion}
                styles={{
                  chevron: {
                    transition: "transform 200ms ease",
                    "&[data-active]": {
                      transform: "rotate(180deg)",
                    },
                  },
                }}
              >
                {Array.isArray(goals) &&
                  goals?.map((goalItem, index) => (
                    <Accordion.Item
                      key={goalItem?.id}
                      value={String(index)}
                      className={classes.essentialAccordionItem}
                    >
                      <Accordion.Control>
                        <Box
                          className={classes.accordionControl}
                          // onClick={handleRecordingConfirm}
                        >
                          <Text color="#262626" fz={16} fw={500} ff="Inter">
                            Goal {""}
                            {goalItem?.goalNumber
                              ? goalItem.goalNumber
                              : index + 1}
                            {/* {index + 1} */}
                          </Text>
                        </Box>
                      </Accordion.Control>

                      <Accordion.Panel>
                        <Grid
                          gutter={26}
                          sx={{
                            paddingBottom: 26,
                          }}
                          className={classes.mwd}
                        >
                          {!view && (
                            <Grid.Col span={12}>
                              <Box mb={26} className={classes.outcomeDeleteBTN}>
                                {/* <Text
                                                    onClick={() =>
                                                      removeGoal(goalItem?.id)
                                                    }
                                                  >
                                                    <AiOutlineDelete size={20} />
                                                    Delete
                                                  </Text> */}
                              </Box>
                            </Grid.Col>
                          )}
                          <Grid.Col xs={12} sm={12} md={5} lg={5} xl={5}>
                            <TimeInput
                              label="Start Time"
                              className={classes.datePicker}
                              icon={
                                <img
                                  style={{ width: "20px" }}
                                  src={"/assets/images/clock.png"}
                                  alt="Icon"
                                />
                              }
                              format="12"
                              value={goalItem?.startTimeGoal || ""}
                              // onChange={(e) => {
                              //   const isSafari =
                              //     /^((?!chrome|android).)*safari/i.test(
                              //       navigator.userAgent
                              //     );
                              //   let time = e.target.value
                              //     .split(":")
                              //     ?.slice(0, 2)
                              //     ?.join(":");
                              //   isSafari
                              //     ? handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "startTimeGoal",
                              //         time,
                              //         index
                              //       )
                              //     : handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "startTimeGoal",
                              //         time,
                              //         index
                              //       );
                              // }}
                              disabled={view}
                            />
                          </Grid.Col>
                          <Grid.Col span={2}>
                            <Flex
                              align="center"
                              justify="center"
                              h="100%"
                              pt={28}
                            >
                              <Text fz={25} color="#000" fw={400}>
                                -
                              </Text>
                            </Flex>
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={5} lg={5} xl={5}>
                            <TimeInput
                              label="End Time"
                              format="12"
                              className={classes.datePicker}
                              icon={
                                <img
                                  style={{ width: "20px" }}
                                  src={"/assets/images/clock.png"}
                                  alt="Icon"
                                />
                              }
                              value={goalItem?.endTimeGoal || ""}
                              // onChange={(e) => {
                              //   const isSafari =
                              //     /^((?!chrome|android).)*safari/i.test(
                              //       navigator.userAgent
                              //     );
                              //   let time = e.target.value
                              //     .split(":")
                              //     ?.slice(0, 2)
                              //     ?.join(":");
                              //   isSafari
                              //     ? handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "endTimeGoal",
                              //         time,
                              //         index
                              //       )
                              //     : handleEssentialSupportDesc(
                              //         goalItem.id,
                              //         "endTimeGoal",
                              //         time,
                              //         index
                              //       );
                              // }}
                              disabled={view}
                            />
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={10} lg={10} xl={10}>
                            <TextInput
                              id="essential-support-type"
                              size="sm"
                              required
                              // data={goalOptions.filter(
                              //   (g) =>
                              //     !goals.some(
                              //       (gi) =>
                              //         gi.identifiedGoal === g.value &&
                              //         gi.id !== goalItem.id
                              //     )
                              // )}
                              label={"Identified Goals"}
                              // className={classes.select}
                              placeholder={"Identified Goals"}
                              readOnly={view}
                              value={goalItem?.identifiedGoal || ""}
                              // disabled={true}
                              // onChange={(value) => {
                              //   handleEssentialTypeChange(
                              //     goalItem?.id,
                              //     "identifiedGoal",
                              //     value,
                              //     index
                              //   );
                              // }}
                              // error={
                              //   essentialSupportErrors[index] &&
                              //   !goalItem?.identifiedGoal &&
                              //   "Support Type is required"
                              // }
                              variant="filled"
                              // mx={{ base: 0, sm: 17 }}
                              my={{ base: 26, sm: 0 }}
                              withAsterisk={false}
                              // rightSectionPointerEvents="none"
                              // rightSection={icon}
                            />
                          </Grid.Col>
                          <Grid.Col xs={12} sm={12} md={2} lg={2} xl={2}>
                            <TextInput
                              id="essential-goalItem-outcome-number"
                              size="sm"
                              required
                              // data={goalNumber || []}
                              label={"Goal #"}
                              // className={classes.select}
                              placeholder={"#"}
                              readOnly={view}
                              value={goalItem?.goalNumber || ""} // ✅ set value
                              // onChange={(value) => {
                              //   handleEssentialNumberChange(
                              //     goalItem?.id,
                              //     "goalNumber",
                              //     value,
                              //     index
                              //   );
                              // }}
                              variant="filled"
                              // mx={{ base: 0, sm: 10 }}
                              // my={{ base: 26, sm: 0 }}
                              withAsterisk={false}
                              // rightSectionPointerEvents="none"
                              // rightSection={icon}
                            />
                          </Grid.Col>
                        </Grid>

                        {goalItems[index]?.map((_gi, gIndex) => (
                          <Grid key={_gi.id} mb={10}>
                            <Grid.Col
                              xs={12}
                              sm={12}
                              md={!view ? 11 : 12}
                              lg={!view ? 11 : 12}
                              xl={!view ? 11 : 12}
                            >
                              <Box className={classes.interventionGoalItem}>
                                <TextInput
                                  id={`essential-goalItem-type-${_gi.id}`}
                                  size="sm"
                                  required
                                  // data={objectivesByGoal.filter(
                                  //   (o) =>
                                  //     !goalItems.some(
                                  //       (g) =>
                                  //         g.objectives === o.value &&
                                  //         g.id !== _gi.id
                                  //     )
                                  // )}
                                  // data={objectivesByGoal}
                                  label="Objective"
                                  // className={classes.select}
                                  placeholder="Objective"
                                  readOnly={view}
                                  value={_gi?.objectives || ""}
                                  // onChange={(value) =>
                                  //   handleGoalActivityChange(
                                  //     _gi.id,
                                  //     "objectives",
                                  //     value,
                                  //     gIndex
                                  //   )
                                  // }
                                  mb={10}
                                  withAsterisk={false}
                                  // rightSectionPointerEvents="none"
                                  // rightSection={icon}
                                />
                                <TextInput
                                  id={`essential-goalItem-frequency-${goalItem.id}`}
                                  size="sm"
                                  required
                                  // data={interventionsByGoal.filter(
                                  //   (i) =>
                                  //     !goalItems.some(
                                  //       (g) =>
                                  //         g.Intervention_Instruction ===
                                  //           i.value && g.id !== _gi.id
                                  //     )
                                  // )}
                                  // data={interventionsByGoal}
                                  label="Intervention"
                                  // className={classes.select}
                                  placeholder="Intervention"
                                  value={_gi?.Intervention_Instruction || ""}
                                  // onChange={(value) =>
                                  //   handleGoalActivityChange(
                                  //     _gi.id,
                                  //     "Intervention_Instruction",
                                  //     value,
                                  //     gIndex
                                  //   )
                                  // }
                                  readOnly={view}
                                  withAsterisk={false}
                                  // rightSectionPointerEvents="none"
                                  // rightSection={icon}
                                />
                              </Box>
                            </Grid.Col>

                            {/* {!view && (
                                                <Grid.Col xs={12} sm={12} md={1} gap={10}>
                                                  <Flex
                                                    direction="column"
                                                    gap={10}
                                                    justify="center"
                                                    align="center"
                                                    h="100%"
                                                  >
                                                    <Button
                                                      onClick={handleAddGoalItem}
                                                      className={
                                                        classes.interventionAddGoalItem
                                                      }
                                                      disabled={view || isAddDisabled}
                                                      sx={{
                                                        opacity:
                                                          view || isAddDisabled ? 0.5 : 1,
                                                        pointerEvents:
                                                          view || isAddDisabled
                                                            ? "none"
                                                            : "auto",
                                                        cursor:
                                                          view || isAddDisabled
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                    >
                                                      <TbPlus
                                                        size={15}
                                                        color="rgba(0, 0, 0, 1)"
                                                      />
                                                    </Button>
                                                    <Button
                                                      onClick={() =>
                                                        handleRemoveGoalItem(_gi.id)
                                                      }
                                                      className={
                                                        classes.interventionAddGoalItem
                                                      }
                                                      disabled={goalItems.length === 1} // keep at least 1 row
                                                      sx={{
                                                        opacity:
                                                          goalItems.length === 1
                                                            ? 0.5
                                                            : 1,
                                                        pointerEvents:
                                                          goalItems.length === 1
                                                            ? "none"
                                                            : "auto",
                                                        cursor:
                                                          goalItems.length === 1
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                    >
                                                      <TbTrash
                                                        size={15}
                                                        color="rgba(0, 0, 0, 1)"
                                                      />
                                                    </Button>
                                                  </Flex>
                                                </Grid.Col>
                                              )} */}
                          </Grid>
                        ))}

                        {/* Behavior Description */}
                        <Textarea
                          id="add-note"
                          className={classes.essentialDiscriptionArea}
                          size="sm"
                          label="Behavior"
                          maxRows={5}
                          minRows={10}
                          placeholder="Enter behavior"
                          value={
                            goalItem?.behaviorDescription?.length > 0
                              ? goalItem?.behaviorDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "behaviorDescription",
                              e?.target?.value,
                              index
                            );
                            let tempNotesArr = essentialNotes;
                            tempNotesArr.splice(index, 1, e?.target?.value);
                            setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                // descriptions={descriptions}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"#FAFAFA"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid #D0D5DD",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}
                        {/* Response Description */}

                        <Textarea
                          id="add-note"
                          className={classes.essentialDiscriptionArea}
                          size="sm"
                          label="Response"
                          maxRows={5}
                          minRows={10}
                          mt={10}
                          placeholder="Enter Response"
                          value={
                            goalItem?.responseDescription?.length > 0
                              ? goalItem?.responseDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "responseDescription",
                              e?.target?.value,
                              index
                            );
                            // let tempNotesArr = essentialNotes;
                            // tempNotesArr.splice(
                            //   index,
                            //   1,
                            //   e?.target?.value
                            // );
                            // setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                // descriptions={descriptions}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"#FAFAFA"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid #D0D5DD",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}

                        {/* Plan description */}
                        <Textarea
                          id="add-note"
                          className={classes.essentialDiscriptionArea}
                          size="sm"
                          label="Plan"
                          mt={10}
                          maxRows={5}
                          minRows={10}
                          placeholder="Enter Plan"
                          value={
                            goalItem?.planDescription?.length > 0
                              ? goalItem?.planDescription
                              : ""
                            // : essentialNotes[index]
                          }
                          onChange={(e) => {
                            handleEssentialSupportDesc(
                              goalItem?.id,
                              "planDescription",
                              e?.target?.value,
                              index
                            );
                            // let tempNotesArr = essentialNotes;
                            // tempNotesArr.splice(
                            //   index,
                            //   1,
                            //   e?.target?.value
                            // );
                            // setEssentialNotes([...tempNotesArr]);
                          }}
                          // disabled={view}
                          readOnly={view}
                          autosize={view}
                        />
                        {/* {!view && (
                                            <>
                                              <AiAssistantChatCard
                                                open={aiAssistantCardOpened}
                                                handleAiAssistantSubmit={
                                                  handleAiAssistantSubmit
                                                }
                                                form={form}
                                                support={goalItem}
                                                messages={goalItem?.message}
                                                sendMessageToOpenAI={sendMessageToOpenAI}
                                                loading={loading}
                                                messageValue={messageValue}
                                                formErrors={formErrors}
                                                setAiAssistantCardOpened={
                                                  setAiAssistantCardOpened
                                                }
                                                essentialSupportIndex={index}
                                              />
                                              {!aiAssistantCardOpened && (
                                                <Flex
                                                  px={19}
                                                  bg={"#FAFAFA"}
                                                  py={8}
                                                  justify="space-between"
                                                  align={"center"}
                                                  gap={12}
                                                  sx={{
                                                    border: "1px solid #D0D5DD",
                                                    borderRadius: "0px 0px 8px 8px",
                                                  }}
                                                >
                                                  <Flex align={"center"} gap={8}>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      Credit Balance:{" "}
                                                    </Text>
                                                    <Text ff={"inter"} fw={500} fz={"md"}>
                                                      {existingRecord?.planType ===
                                                      "monthly-subscription"
                                                        ? "Unlimited"
                                                        : Number(
                                                            existingRecord?.adminTotalTokens
                                                          )}
                                                    </Text>
                                                  </Flex>
                                                  <Flex align={"center"} gap={8}>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        (existingRecord.active ===
                                                          false &&
                                                          existingRecord.paid === false)
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          (existingRecord.active ===
                                                            false &&
                                                            existingRecord.paid === false)
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={() => {
                                                        handleMicStart("essential");
                                                      }}
                                                    >
                                                      <MicAiSvg
                                                        color={
                                                          view ||
                                                          (existingRecord.adminTotalTokens ===
                                                            "" &&
                                                            existingRecord.planType ===
                                                              "onetime-purchase")
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                    <UnstyledButton
                                                      disabled={
                                                        view ||
                                                        !goalItem?.description ||
                                                        goalItem?.description === ""
                                                      }
                                                      style={{
                                                        cursor:
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "not-allowed"
                                                            : "pointer",
                                                      }}
                                                      onClick={handleAiAssistantSubmit}
                                                    >
                                                      <AutoFillSvg
                                                        color={
                                                          view ||
                                                          !goalItem?.description ||
                                                          goalItem?.description === ""
                                                            ? "#A0A0A0"
                                                            : "#000"
                                                        }
                                                      />
                                                    </UnstyledButton>
                                                  </Flex>
                                                </Flex>
                                              )}
                                            </>
                                          )}
                                          <RecordingControls
                                            isListening={isListening}
                                            recordingTime={recordingTime}
                                            onRedo={handleRedo}
                                            onCancel={handleRecordingCancel}
                                            onConfirm={handleRecordingConfirm}
                                            classes={classes}
                                          /> */}
                        <TextInput
                          mt={16}
                          id="about-goal"
                          size="sm"
                          radius={"md"}
                          className={classes.select}
                          data={[
                            "Yes",
                            "No",
                            "Goal in progress",
                            "Not Applicable",
                          ]}
                          label="Was this goal met?"
                          placeholder="Select a response"
                          value={goalItem?.metGoalIntervention}
                          // onChange={(value) => {
                          //   handleEssentialSupportDesc(
                          //     goalItem?.id,
                          //     "metGoalIntervention",
                          //     value,
                          //     index
                          //   );
                          // }}
                          disabled={view}
                          rightSectionPointerEvents="none"
                          rightSection={icon}
                        />
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </Box>
          )}

            {profile?.user?.type === "staff" &&
                        profile?.user?.role !== "admin" &&
                              data?.data?.approvalStatus === "pending" && (
                                <Box className={classes.rejectedNote}>
                                  <Box className={classes.rejectionIconBox}>
                                    <NotePendingSvg />
                                    <Text ff={"Inter"} fz={14} fw={500} color="#000">
                                      Pending Approval
                                    </Text>
                                  </Box>
                                </Box>
                              )}

          {view ? (
            <div />
          ) : (
            <SimpleGrid cols={isMobileScreen ? 1 : 2}>
              <Button
                radius={8}
                color="red"
                variant="light"
                onClick={resetForm}
                leftIcon={<IconX />}
                sx={{ marginLeft: "auto", width: isMobileScreen ? "100%" : 122, fontFamily: "Inter" }}
              >
                Cancel
              </Button>
              <Button
                id="save-note-button"
                color="yellow"
                sx={{
                  width: isMobileScreen ? "100%" : 122,
                  marginRight: "auto",
                  fontFamily: "Inter",
                }}
                styles={(theme) => ({
                  root: {
                    color: "#000",
                  },
                })}
                radius={8}
                type="submit"
                loading={addNoteLoading}
              >
                Save
              </Button>
            </SimpleGrid>
          )}

          {/* rejection and approved notes */}
          {showRejection && !showRejectedNote && !hideApproveRejectButtons && (
            <Box className={classes.rejectionContainer}>
              <Box className={classes.rejectionBox}>
                <Box className={classes.rejection} mb={5}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#000">
                    Reason of Rejection
                  </Text>
                  <RxCross2
                    size={20}
                    className={classes.crossIcon}
                    onClick={() => handleShowRejection()}
                  />
                </Box>
                <Select
                  size="md"
                  radius="md"
                  label={<div style={{ marginBottom: 5 }}>Reason</div>}
                  placeholder="Select reason"
                  rightSection={<IconChevronDown size={16} />}
                  data={[
                    {
                      value: "Missing Required Information",
                      label: "Missing Required Information",
                    },
                    {
                      value: "No Connection to ISP Goals or Outcome",
                      label: "No Connection to ISP Goals or Outcome",
                    },
                    {
                      value: "Insufficient Detail",
                      label: "Insufficient Detail",
                    },
                    {
                      value: "Incorrect or Missing Dates/Times",
                      label: "Incorrect or Missing Dates/Times",
                    },
                    {
                      value: "Not Aligned with Assigned Shift",
                      label: "Not Aligned with Assigned Shift",
                    },
                  ]}
                  value={noteRejectValue}
                  onChange={(selected) => {
                    setNoteRejectValue(selected);
                    setReasonError("");
                  }}
                  error={reasonError && "Reason field is required"}
                />
                <Textarea
                  rows={6}
                  minRows={3}
                  mt={3}
                  size="md"
                  radius="md"
                  value={noteRejectionDescp}
                  label={
                    <div style={{ marginBottom: 5 }}>
                      Description (Optional)
                    </div>
                  }
                  placeholder="Enter reason of rejection"
                  onChange={(event) =>
                    setNoteRejectionDescp(event.target.value)
                  }
                />
              </Box>
              <Button
                size="md"
                c={"#fff"}
                color="red"
                radius={"md"}
                variant="filled"
                w={"fit-content"}
                onClick={() => {
                  handleReject();
                }}
              >
                Reject
              </Button>
            </Box>
          )}

          {/* {profile?.user?.type === "staff" &&
            profile?.user?.role !== "admin" &&
            noteData?.data?.approvalStatus === "pending" && (
              <Box className={classes.rejectedNote}>
                <Box className={classes.rejectionIconBox}>
                  <MdPendingActions size={30} color="orange" />
                  <Text ff={"Inter"} fz={14} fw={500} color="#000">
                    Note Pending
                  </Text>
                </Box>
              </Box>
            )} */}

          {((showRejectedNote ||
            noteData?.data?.approvalStatus === "rejected") && !hideApproveRejectButtons) && (
            <>
              <Box className={classes.rejectedNote}>
                <Box className={classes.rejectionIconBox}>
                  <RejectNoteSvg />
                  <Text ff={"Inter"} fz={14} fw={500} color="#000">
                    Note Rejected
                  </Text>
                </Box>
                <>
                  <Divider my="sm" />
                  <Box className={classes.rejectionBoxReason}>
                    <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                      Reason
                    </Text>
                    <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                      {noteData?.data?.rejectionReason || "-"}
                    </Text>
                    <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                      Description
                    </Text>
                    <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                      {noteData?.data?.rejectionDescriptions || "-"}
                    </Text>
                  </Box>
                </>
              </Box>
              {/* {profile?.user?.type === "staff" && (
                <Flex justify="flex-end">
                  <Button
                    size="md"
                    c={"#fff"}
                    color="gray"
                    radius={"md"}
                    variant="filled"
                    w={"fit-content"}
                  >
                    Edit
                  </Button>
                </Flex>
              )} */}
            </>
          )}
          {(showApproved || noteData?.data?.approvalStatus === "approved") && !hideApproveRejectButtons && (
            <Box className={classes.approvedNote}>
              <ApprovedNoteSvg />
              <Text ff={"Inter"} fz={14} fw={500} color="#000">
                Note Approved
              </Text>
            </Box>
          )}
          {!showRejection &&
            !showApproved &&
            !hideApproveRejectButtons &&
            // (profile?.user?.role === "admin" && !profile?.user?.role) &&
            (!profile?.user?.type || profile?.user?.role == "admin") &&
            noteData?.data?.approvalStatus !== "approved" &&
            noteData?.data?.approvalStatus !== "rejected" && (
              <Box className={classes.btns}>
                <Button
                  c={"#B42318"}
                  size="md"
                  color="red"
                  radius={"md"}
                  variant="light"
                  style={{ background: "#FEF3F2" }}
                  onClick={() => setShowRejection(true)}
                >
                  Reject
                </Button>
                <Button
                  size="md"
                  c={"#000"}
                  radius={"md"}
                  color="yellow"
                  variant="filled"
                  onClick={() => {
                    setShowApproved(true);
                    setShowRejectedNote(false);
                    handleApprove();
                  }}
                >
                  Approve
                </Button>
              </Box>
            )}
        </form>
      </Drawer>
      {/* </div>
      </div> */}
    </>
  );
};

export default NoteModalNew;
